export const TennMobClientTypes = [ '10nMobile', '10nMobileLocal' ];

export const TennWebClientTypes = [ '10nWeb', '10nWebLocal' ];

export const HammerWebClientTypes = [ 'HammerWeb', 'HammerWebLocal' ];

export const MyPortalTradeClientTypes = [ 'MyPortalTrade', 'MyPortalTradeLocal' ];

export const TennWealthWebClientTypes = [ '10nWealthWeb', '10nWealthWebLocal' ];

export const PariCapitalClientTypes = [ 'DemoAceCapitalPortal', 'DemoAceCapitalPortalLocal' ];

export const AcePortalClientTypes = [ 'AcePortal', 'AcePortalLocal' ];
